export default __webpack_public_path__ + "media/images/ico-344542bc23b714c26eb266f3ffda3c47.png";